import { isNarrowScreen } from "./utils";
const defaultDropzoneStyles = {
  rejected: {
    borderStyle: "solid",
    borderColor: "#c66",
    backgroundColor: "#eee",
  },
  disabled: {
    opacity: 0.5,
  },
  active: {
    borderStyle: "solid",
    borderColor: "#6c6",
    backgroundColor: "#eee",
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: "#666",
    borderStyle: "dashed",
    borderRadius: 5,
  },
};

export const getOverlayStyles = {
  fontSize: "14px",
  width: isNarrowScreen ? "160px" : "220px",
  height: isNarrowScreen ? "160px" : "254px",
};

export const inputStyles = {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  opacity: 0.00001,
  pointerEvents: "none",
};

export const getAppliedStyle = ({
  style,
  noStyles,
  activeStyle,
  acceptStyle,
  rejectStyle,
  disabledStyle,
  isDragActive,
  isDragAccept,
  isDragReject,
  disabled,
}) => {
  if (noStyles) {
    style = defaultDropzoneStyles.default;
    activeStyle = defaultDropzoneStyles.active;
    acceptStyle = defaultDropzoneStyles.active;
    rejectStyle = defaultDropzoneStyles.rejected;
    disabledStyle = defaultDropzoneStyles.disabled;
  }

  let appliedStyle = { position: "relative", ...style };
  if (activeStyle && isDragActive) {
    appliedStyle = { ...appliedStyle, ...activeStyle };
  }
  if (acceptStyle && isDragAccept) {
    appliedStyle = { ...appliedStyle, ...acceptStyle };
  }
  if (rejectStyle && isDragReject) {
    appliedStyle = { ...appliedStyle, ...rejectStyle };
  }
  if (disabledStyle && disabled) {
    appliedStyle = { ...appliedStyle, ...disabledStyle };
  }

  return appliedStyle;
};



// WEBPACK FOOTER //
// ./components/common/file-uploader/styles.js